'use client';

import { useEnvironment } from '@/hooks/use-environment';
import type { PropsWithChildren } from 'react';

/**
 * Renders its children only when the logged-in user is a Pigello user, i.e.
 * their email ends with `@pigello.se` (and is verified). Renders nothing
 * otherwise.
 */
export function IfPigelloUser({ children }: PropsWithChildren) {
  const { isPigelloUser } = useEnvironment();

  if (!isPigelloUser) {
    return null;
  }

  return <>{children}</>;
}
